import axios from "axios";

const REACT_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;


// Create Axios instances with dynamic base URLs
const api = axios.create({
    baseURL: `${REACT_BACKEND_URL}/auth`,
});

const api1 = axios.create({
    baseURL: `${REACT_BACKEND_URL}`,
});

export const googleAuth = (code) => api.get(`/google?code=${code}`);



// export const historyfetch = (email) => api.get('/api/fetch-analysis')


// History Fetch API
export const historyfetch = (email) =>
    api1.get(`/api/fetch-analysis`, {
        params: { email }, // Send email as a query parameter
        headers: {
            'Content-Type': 'application/json'
        }
    });